import { disciplinePhasesManager } from './phases/DisciplinePhasesManager'
import {
  AudioNames,
  BlueBoxTextType,
  DisciplinePhases
} from './types'
import {
  audioManager,
  corePhasesManager,
  fpsManager,
  gsap,
  modes,
  playersManager
} from '@powerplay/core-minigames'
import { startPhaseStateManager } from './phases/StartPhase/StartPhaseStateManager'
import {
  stateManager,
  StateManager
} from './StateManager'
import {
  startPhaseState,
  textMessageState,
  timeState,
  uiState,
} from '@/stores'
import { miniTableState } from '@/stores/miniTableState'
import { gameConfig } from './config'

/**
 * Trieda pre casovy limit
 */
export class TimeLimitManager {

  /** Ci akurat je out of time */
  public isOutOfTime = false

  /** Pocitadlo frameov pre casovy limit */
  private frameCounter = 0

  /** Ci je aktivny */
  private isActive = false

  /** ci delay na out of time skoncil */
  private outOfTimeDelayEnded = false

  /**
   * Nastavenie aktivnosti casoveho limitu
   * @param active - Ci sa ma aktivovat alebo deaktivovat
   */
  public setActive(active: boolean): void {

    this.isActive = active

  }

  /**
   * Skontrolovanie casoveho limitu
   * @returns Ci uz skoncil casovy limit
   */
  public check(): boolean {

    if (!this.isActive) return false

    this.frameCounter += 1
    let time = (gameConfig.timeLimit - this.frameCounter) / fpsManager.fpsLimit
    if (time < 0) time = 0
    startPhaseState().startTimer = time

    // kontrolujeme ci sa ma uz skoncit na zaklade casoveho limitu
    if (this.frameCounter >= gameConfig.timeLimit) {

      console.log('CASOVY LIMIT UPLYNUL')
      this.isOutOfTime = true
      this.setActive(false)
      timeState().showCountdown = false

      // zapiseme vysledok
      playersManager.setPlayerResults(0, 1, 0)
      playersManager.setStandings()

      stateManager.showAttemptsTable()

      if (modes.isTournament()) {

        // endManager.resultsCount += 1

      }

      uiState().blueBoxTextType = BlueBoxTextType.hidden

      const showFirstLine = true
      const showSecondLine = false
      startPhaseStateManager.resetTextMessageFinishedEmits(showFirstLine, showSecondLine)

      textMessageState().$patch({
        showFirstLine: showFirstLine,
        showSecondLine: showSecondLine,
        firstLineText: 'out-of-time',
        firstLineTextType: 0,
        secondLineTextType: 2,
        secondLineLeftNumber: 0,
        showMessage: true,
        showType: 3
      })
      miniTableState().$patch({
        rowsData: StateManager.getDataForMiniTable(),
        show: corePhasesManager.disciplineActualAttempt % corePhasesManager.provisionalResultsFrequency !== 0 &&
              !modes.isTutorial() && !modes.isTrainingMode()
      })

      audioManager.fadeOutAudio(AudioNames.audienceClapping, 500)

      gsap.to({}, {
        onComplete: () => {

          this.outOfTimeDelayEnded = true

          startPhaseStateManager.hideTextMessage(1)
          startPhaseStateManager.hideTextMessage(2)

        },
        duration: 1.5
      })

      disciplinePhasesManager.startDisciplinePhase(DisciplinePhases.finish)

      disciplinePhasesManager.phaseDraw.finishPhase()
      return this.outOfTimeDelayEnded

    }

    return false

  }

  /**
   * Resetovanie veci
   */
  public reset(): void {

    this.frameCounter = 0
    this.isActive = false
    this.outOfTimeDelayEnded = false
    this.isOutOfTime = false

  }

}

export const timeLimitManager = new TimeLimitManager()
